import React from "react"

import NavigationMenuItem from "../../../../layout/menu/menu-items/menu-item"
import {AddView_Group, AddView_GroupType} from "../@types";

type Props = {
    viewsStructure  : AddView_Group[]
    selectedGroupId : ID

    onSelect        : {(selectedGroup:AddView_Group):void}
}

export default function NavigationMenuAddViewLeft(props:Props) {
    return (
        <div className="left flex-column-left-top">
            <div className="flex-row-left-center flex-no-shrink ui5-txt-not-important fw-600 h-36 p-l-15 m-t-3">
                New View
            </div>
            <div className="ui5-menu w-100-percent p-t-0">
                {_.map(props.viewsStructure, (group, key:number)=> {

                    if (group.type === AddView_GroupType.SEPARATOR) {
                        return <div className="separator-h" key={key}/>
                    }

                    return <NavigationMenuItem key              = {group.id}
                                               className        = "view-group"
                                               showArrow        = {!group.skipItemsList}
                                               icon             = {group.icon!}
                                               name             = {group.title!}
                                               selected         = {group.id === props.selectedGroupId}
                                               onClick          = {() => props.onSelect(group)}/>
                })}
            </div>
        </div>
    )
}
